/* Teresa Staub Jewelry — minimal, progressiv. Bewusst wenig JS
   (Core Web Vitals / GEO: wichtige Inhalte serverseitig gerendert). */
(function () {
  'use strict';

  // Mobile-Navigation umschalten
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (!toggle) return;
    var nav = document.querySelector('[data-nav]');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('nav-locked', open);
  });

  // Header verkleinern beim Scrollen (dezent)
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
